import { useUserPermissions } from './useUserPermissions';

export const usePermissionCheck = (permissionCheck) => {
  const userPermissions = useUserPermissions();

  // No key means the action is unrestricted (e.g. RPE, which has no view gate).
  // Without this, `permissionCheck={null}` would read as "permission missing" and
  // disable the control.
  if (!permissionCheck) {
    return { permissionDisabled: false };
  }

  // The backend enforces every key on every team, whatever `platform_permissions_enabled`
  // says, so the frontend must too or it sends requests that 403.
  const permissionDisabled = !userPermissions?.[permissionCheck];
  return {
    permissionDisabled,
  };
};
